import { render, staticRenderFns } from "./genter-dialog.vue?vue&type=template&id=4a5004cc&"
import script from "./genter-dialog.vue?vue&type=script&lang=js&"
export * from "./genter-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports